import { PartnerConfig } from "../tenant.types";

const SUFIXO_DOMINIO = /\.ivienergia\.com$/;
const PREFIXO_AMBIENTE = /^(dev|hml|stg)\./;
const SUFIXO_FLUXO = /-cadastro(-parceiro)?$/;

const MARCAS: Record<string, PartnerConfig> = {
  benup: "BENUP",
};

const normalizar = (tenantUrl: string) =>
  tenantUrl
    .toLowerCase()
    .replace(SUFIXO_DOMINIO, "")
    .replace(PREFIXO_AMBIENTE, "")
    .replace(SUFIXO_FLUXO, "");

const resolverMarca = (tenantUrl: string): PartnerConfig => MARCAS[normalizar(tenantUrl)] ?? "DEFAULT";

export { resolverMarca };
